<div class="header-ui-switcher">
  <button
    *ngIf="!isNewUI"
    nbButton
    status="success"
    size="medium"
    (click)="switchUI()"
    class="switch-button new-ui-button icon-only"
    nbTooltip="Découvrez la nouvelle interface repensée"
    nbTooltipPlacement="bottom"
    aria-label="Try new UI">
    <nb-icon icon="bolt"></nb-icon>
    <span class="btn-text">Accèder à la nouvelle interface du BO</span>
  </button>

  <button
    *ngIf="isNewUI"
    nbButton
    status="basic"
    size="medium"
    (click)="switchUI()"
    class="switch-button classic-ui-button icon-only"
    nbTooltip="Revenir à l’interface classique stable"
    nbTooltipPlacement="bottom"
    aria-label="Back to stable UI">
    <nb-icon icon="arrow-left"></nb-icon>
    <span class="btn-text">Revenir à l'ancienne interface du BO</span>
  </button>
</div>